export default __webpack_public_path__ + "static/media/why_cm.c740fd5b.png";